import React from 'react';
import { Route, Redirect, Switch, RouteChildrenProps } from 'react-router';

import LoginPage from './components/LoginPage';
import RegistrationPage from './components/RegistrationPage';
import RecoveryPage from './components/RecoveryPage';

import logo from 'img/OLogo.png';

const AuthPage: React.SFC<RouteChildrenProps> = () => (
  <React.Fragment>
    <nav className="navbar navbar-expand-md align-items-center abs">
      <div className="container-fluid d-none d-lg-flex">
        <div className="navbar-brand">
          <img src={logo} className="logo" />
        </div>
        <div className="navbar-text tel text-right">
          Автомобили: +7 (916) 345-01-97 <br/> Недвижимость: +7 (916) 939-02-06
        </div>
      </div>
      <div className="container d-flex d-lg-none">
        <div className="navbar-brand">
          <img src={logo} className="logo logo-reg" />
        </div>
        <div className="navbar-text tel text-right">
          Автомобили: +7 (916) 345-01-97 <br/> Недвижимость: +7 (916) 939-02-06
        </div>
      </div>
    </nav>
    <Switch>
      <Redirect exact={true} from="/auth" to="/auth/login" />
      <Route path={'/auth/login'} component={LoginPage} />
      <Route path={'/auth/registration'} component={RegistrationPage} />
      <Route path={'/auth/checkIn'} component={RegistrationPage} />
      <Route path={'/auth/recovery'} component={RecoveryPage} />
    </Switch>
  </React.Fragment>
);

export default AuthPage;
